import { api } from "@/constants"
import { getAuthHeader, serializeQueryParams } from "@/util"
import baseURL from "@/service/api"

const voucher = {
  getVouchers: (params) => {
    const url = api.voucher.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },

  createVoucher: (payloads) => {
    const url = api.voucher.create
    return baseURL.post(url, payloads, {
      headers: getAuthHeader()
    })
  },

  getVoucherDetail: (id) => {
    const url = api.voucher.detail(id)
    return baseURL.get(url, { headers: getAuthHeader() })
  },

  updateVoucher: (id, payloads) => {
    const url = api.voucher.detail(id)
    return baseURL.put(url, payloads, {
      headers: getAuthHeader()
    })
  },

  deleteVoucher: (id) => {
    const url = api.voucher.detail(id)
    return baseURL.delete(url, { headers: getAuthHeader() })
  }
}

export default voucher
